module.exports = __webpack_public_path__ + "static/media/circle-check.26d9a2c1.svg";